export const CONFIGURE_TAB = {
    processes: 'processes',
    playbooks: 'playbooks',
    cycles: 'cycles',
};
